import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
 
@Injectable({
  providedIn: 'root',
})

export class AuthGuard implements CanActivate {
  private isAuthenticated: boolean = false; // Default value for authentication status
  driver_ID:number=0;
  constructor(private router: Router) {}
 
  // Check access
  canActivate(): boolean {
    if (this.isAuthenticated) {
      return true; // Allow access to the route
    } else {
      // Redirect to the login page if not authenticated
      this.router.navigate(['/login']);
      return false;
    }
  }
 
  // Simulate login after OTP verification
  authenticateUser(id:number) {
    this.driver_ID=id;
    this.isAuthenticated = true; // Mark the user as authenticated
  }
 
  // Simulate logout
  logoutUser() {
    this.driver_ID=0;
    this.isAuthenticated = false; // Mark the user as unauthenticated
  }
}